import { StoreActionType as Type } from "../../types";

const initialState: any = {};

export const currentUserReducer: any = (state: any = initialState, action: any) => {
  switch (action.type) {
    case Type.SET_CURRENT_USER:
      return {
        ...state,
        ...action?.info,
      };

    default:
      return state;
  }
};
